﻿// @ts-nocheck
// AI assistant

// ========== AI Helper ==========
let aiHistory = [
  {
    role: "assistant",
    content: "I can see your projects, sessions, jobs, and invoices. Ask me about billing, planning, or what needs attention next.",
  },
];
let aiBusy = false;

function appendAiMessage(role, content) {
  const aiMessagesEl = document.getElementById("aiMessages");
  if (!aiMessagesEl) return;

  const wrapper = document.createElement("div");
  wrapper.className = `ai-message ${role === "assistant" ? "assistant" : ""}`;
  wrapper.innerHTML = `
    <div class="ai-role">${role === "user" ? "You" : "Assistant"}</div>
    <div class="ai-content"></div>
  `;
  wrapper.querySelector(".ai-content").textContent = content;
  aiMessagesEl.appendChild(wrapper);
  aiMessagesEl.scrollTop = aiMessagesEl.scrollHeight;
}

async function sendAiQuestion(text) {
  if (!text || aiBusy) return;

  aiBusy = true;
  const aiSendBtn = document.getElementById("aiSendBtn");
  const aiStatusEl = document.getElementById("aiStatus");
  const aiInput = document.getElementById("aiInput");

  if (aiSendBtn) aiSendBtn.disabled = true;
  if (aiStatusEl) aiStatusEl.textContent = "Thinking...";

  appendAiMessage("user", text);
  aiHistory.push({ role: "user", content: text });
  if (aiInput) aiInput.value = "";

  try {
    const res = await fetchWithAuth("/api/ai-helper", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ messages: aiHistory }),
    });

    if (!res.ok) throw new Error("AI helper error");

    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let responseText = "";
    let suggestedChanges = null;

    const aiMessagesEl = document.getElementById("aiMessages");
    const assistantWrapper = document.createElement("div");
    assistantWrapper.className = "ai-message assistant";
    assistantWrapper.innerHTML = `
      <div class="ai-role">Assistant</div>
      <div class="ai-content"></div>
      <div class="ai-actions" style="margin-top: 0.75rem; display: none;"></div>
    `;
    const assistantContentEl = assistantWrapper.querySelector(".ai-content");
    const assistantActionsEl = assistantWrapper.querySelector(".ai-actions");
    aiMessagesEl.appendChild(assistantWrapper);

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      const chunk = decoder.decode(value, { stream: true });
      const lines = chunk.split("\n");
      for (const line of lines) {
        if (!line.trim()) continue;
        try {
          const jsonData = JSON.parse(line);
          if (jsonData.response) {
            responseText += jsonData.response;
            assistantContentEl.textContent = responseText;
            aiMessagesEl.scrollTop = aiMessagesEl.scrollHeight;
          }
        } catch (e) {
          // Ignore JSON parse errors
        }
      }
    }

    // Check if response contains AI-suggested changes
    if (responseText) {
      console.log("Full AI response:", responseText);
      const jsonMatch = responseText.match(/```json\n([\s\S]*?)\n```/);
      if (jsonMatch) {
        console.log("Found JSON block:", jsonMatch[1]);
        try {
          const parsed = JSON.parse(jsonMatch[1]);
          console.log("Parsed AI suggestion:", parsed);
          if (parsed.action === "suggest_changes" && parsed.changes) {
            console.log("Setting pendingAiChanges to:", parsed.changes);
            pendingAiChanges = parsed.changes;
            // Show the text without the JSON block
            const cleanText = responseText.replace(/```json\n[\s\S]*?\n```\n?/, "").trim();
            assistantContentEl.textContent = cleanText;
            
            // Show action buttons
            assistantActionsEl.style.display = "flex";
            assistantActionsEl.style.gap = "0.5rem";
            assistantActionsEl.innerHTML = `
              <button class="btn btn-success btn-sm" onclick="applyAiChanges()">✓ Apply Changes</button>
              <button class="btn btn-secondary btn-sm" onclick="pendingAiChanges = null; this.parentElement.parentElement.remove()">✕ Dismiss</button>
            `;
          } else if (parsed.action === "generate_invoice" && parsed.month && parsed.projectName) {
            console.log("Generating invoice for:", parsed.projectName, "in", parsed.month);
            const cleanText = responseText.replace(/```json\n[\s\S]*?\n```\n?/, "").trim();
            assistantContentEl.textContent = cleanText;
            
            // Show action button to generate invoice
            assistantActionsEl.style.display = "flex";
            assistantActionsEl.style.gap = "0.5rem";
            assistantActionsEl.innerHTML = `
              <button class="btn btn-success btn-sm" onclick="aiGenerateInvoice('${parsed.month}', '${parsed.projectName}')">📄 Generate Invoice</button>
              <button class="btn btn-secondary btn-sm" onclick="this.parentElement.parentElement.remove()">✕ Dismiss</button>
            `;
          } else {
            console.log("JSON parsed but missing required fields", parsed);
          }
        } catch (e) {
          console.error("Failed to parse AI suggestions:", e);
          // If JSON parsing fails, just show the full response
        }
      } else {
        console.log("No JSON block found in response");
      }
      
      aiHistory.push({ role: "assistant", content: responseText });
    }
    if (aiStatusEl) aiStatusEl.textContent = "Idle";
  } catch (err) {
    console.error(err);
    if (aiStatusEl) aiStatusEl.textContent = "Error";
  } finally {
    aiBusy = false;
    if (aiSendBtn) aiSendBtn.disabled = false;
  }
}

async function applyAiChanges() {
  if (!pendingAiChanges) {
    alert("No changes to apply");
    return;
  }

  const changes = pendingAiChanges;
  pendingAiChanges = null;
  
  try {
    console.log("Applying changes:", changes);
    
    // Warn if timestamps look wrong
    const todayMidnight = new Date();
    todayMidnight.setHours(0, 0, 0, 0);
    const tomorrowMidnight = new Date(todayMidnight);
    tomorrowMidnight.setDate(tomorrowMidnight.getDate() + 1);
    
    const badTimestamps = changes.filter(c => 
      c.startTime < todayMidnight.getTime() || c.startTime >= tomorrowMidnight.getTime()
    );
    
    if (badTimestamps.length > 0) {
      console.warn("⚠️  Sessions outside today's range:", badTimestamps);
      const badDates = badTimestamps.map(c => new Date(c.startTime).toLocaleDateString()).join(", ");
      console.warn("These sessions are for: " + badDates);
      alert("⚠️ Warning: Some sessions are NOT for today:\n" + badDates + "\n\nThey won't show in today's table but are saved. Ask AI to create sessions for TODAY specifically.");
    }
    
    const timezoneOffset = new Date().getTimezoneOffset();
    const res = await fetchWithAuth("/api/ai-apply-changes", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ changes, timezoneOffset }),
    });

    console.log("Response status:", res.status);
    const result = await res.json();
    console.log("Response result:", result);
    
    if (!res.ok) {
      throw new Error(result.error || "Failed to apply changes");
    }
    
    // Show detailed results
    const successCount = result.results.filter(r => r.success).length;
    const failureCount = result.results.filter(r => !r.success).length;
    
    let message = `✓ Applied changes: ${successCount} successful`;
    if (failureCount > 0) message += `, ${failureCount} failed`;
    message += `\n\n${result.results.map(r => (r.success ? '✓' : '✗') + ' ' + r.message).join('\n')}`;
    
    if (badTimestamps.length === 0) {
      message += "\n\n✓ Sessions are for today and should appear below!";
    }
    
    alert(message);
    
    // Force a slight delay then reload to ensure KV is updated
    setTimeout(async () => {
      console.log("Reloading sessions...");
      await loadSessions();
      populateMonthSelect();
    }, 500);
  } catch (err) {
    console.error("Error applying changes:", err);
    alert("Error applying changes: " + err.message);
  }
}
